










 

 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettings_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "events",
      "storageKey": null
    }
  ],
  "type": "TeamNotificationSettings",
  "abstractKey": null
};

(node ).hash = "39527d2ffec2aa95ef4a915c694a4785";

export default node;
